"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FooterWithButtons", {
  enumerable: true,
  get: function get() {
    return _FooterWithButtons["default"];
  }
});
var _FooterWithButtons = _interopRequireDefault(require("./FooterWithButtons"));